import { BookAlphabetIcon } from './BookAlphabetIcon';

/**
 * author: Christopher Schreiner
 * id 250BF541-072A-4773-8BC2-B1943DF1EDBB
 * name book-alphabet
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book-alphabet.svg
 * tags
 */
export const DictionaryIcon = BookAlphabetIcon;
export default DictionaryIcon